import { useState, useCallback } from 'react'

export const STEP = {
  ENTRY: 'entry',
  TEL: 'tel',
  FINISH: 'finish',
} as const

export type Step = (typeof STEP)[keyof typeof STEP]

export const useBookingWorkRecordStep = () => {
  const [currentStep, setCurrentStep] = useState<Step>(STEP.ENTRY)

  const goToEntry = useCallback(() => {
    setCurrentStep(STEP.ENTRY)
  }, [])

  const goToTelInput = useCallback(() => {
    setCurrentStep(STEP.TEL)
  }, [])

  const goToFinish = useCallback(() => {
    setCurrentStep(STEP.FINISH)
  }, [])

  return {
    currentStep,
    goToEntry,
    goToTelInput,
    goToFinish,
  }
}
